import React, { useState, useEffect } from 'react';
import Latex from 'react-latex-next';
import Snackbar from '@material-ui/core/Snackbar';
import { AiFillCopy } from 'react-icons/ai';

import {
  CalcSolution,
  SolutionWrapper,
  Parag,
  CopyButton,
} from '../../styled/stylezz';

const SolutionCalc = ({ inputA, demension: dem, demA, demS }) => {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [sol, setSol] = useState('');
  const [answerLatex, setAnswerLatex] = useState('');
  const [per, setPer] = useState('');
  const [A, setA] = useState('');
  let demStr;

  switch (demS) {
    case 1:
      demStr = 'м';
      break;
    case 100:
      demStr = 'см';
      break;
    case 1000:
      demStr = 'мм';
      break;
    default:
      demStr = 'м';
      break;
  }
  useEffect(() => {
    if (demA !== demS) {
      const vel = (inputA * demS) / demA;
      setA(vel);
      const per = (
        <>
          <Parag>Преобразуем все величины к единому значению:</Parag>
          <CalcSolution>
            {dem} = {inputA} = {A}
            {` (${demStr})`}
          </CalcSolution>
        </>
      );
      setPer(per);
      return;
    }
    setA(inputA);
  }, [inputA, demA, demS, demStr, dem, A]);

  useEffect(() => {
    if (dem === 'r') {
      const sol = A * A * Math.PI;
      setSol(sol);
      const answerLatex = `$$S=\\pi\\cdot r^{2}=\\pi\\cdot ${A}^{2}=\\pi\\cdot ${
        A * A
      } \\approx${sol} \\quad $$`;
      setAnswerLatex(answerLatex);
    } else if (dem === 'd') {
      const sol = (Math.PI * A * A) / 4;
      setSol(sol);
      const answerLatex = `$$S=\\frac{\\pi\\cdot d^{2}}{4} = \\frac{\\pi\\cdot ${A}^{2}}{4} = \\frac{\\pi\\cdot ${
        A * A
      }}{4} \\approx${sol} \\quad$$`;
      setAnswerLatex(answerLatex);
    } else if (dem === 'L') {
      const sol = (A * A) / (4 * Math.PI);
      setSol(sol);
      const answerLatex = `$$S=\\frac{l^{2}}{4\\cdot\\pi} = \\frac{${A}^{2}}{4\\cdot\\pi} = \\frac{${
        A * A
      }}{4\\cdot\\pi} \\approx${sol} \\quad$$`;
      setAnswerLatex(answerLatex);
    }
  }, [A, dem, demStr, inputA]);

  const handleCopy = () => {
    navigator.clipboard.writeText(sol);
    setOpenSnackBar(true);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  return (
    <SolutionWrapper>
      {!(inputA > 0) ? (
        <CalcSolution>
          Такой окружности не существует!
          <div>Ваше значение = {inputA}</div>
        </CalcSolution>
      ) : (
        <>
          {per}
          <Parag>Ответ:</Parag>
          <CalcSolution>
            <Latex strict={false}>{answerLatex}</Latex>
            <div style={{ textAlign: 'center' }}>
              S = {sol}{' '}
              <span>
                {demStr}
                <sup>2</sup>
              </span>
            </div>
            <CopyButton onClick={handleCopy}>
              <AiFillCopy
                size={20}
                style={{ color: '#5095df', marginRight: '10px' }}
              />
              Копировать ответ
            </CopyButton>
            <Snackbar
              achororigin={{
                vertical: 'center',
                horizontal: 'center',
              }}
              open={openSnackBar}
              autoHideDuration={2000}
              message="Ответ скопирован"
              onClose={handleClose}
              ContentProps={{
                style: {
                  background: '#5095df',
                },
              }}
            />
          </CalcSolution>
        </>
      )}
    </SolutionWrapper>
  );
};

export default SolutionCalc;
